import cx from 'classnames';
import type { MouseEvent } from 'react';

// icons
import { ReactComponent as ArrowSortASC } from 'assets/image/icons/arrow-sort-asc.svg';
import { ReactComponent as ArrowSortDESC } from 'assets/image/icons/arrow-sort-desc.svg';

// types
import { SortDirection } from '@joc/api-gateway';

// styles
import styles from './TableHeadCellSortable.module.scss';

interface ISort<T> {
	sortBy?: T;
	sortDir?: SortDirection;
}

type TableHeadCellSortableProps<T> = {
	sortBy: T;
	title: string;
	handleSortChange: (sortBy: T, direction?: SortDirection) => void;
	sort?: ISort<T>;
	minWidth?: string;
};

const TableHeadCellSortable = <T,>({
	sortBy,
	title,
	handleSortChange,
	sort,
	minWidth,
}: TableHeadCellSortableProps<T>) => {
	return (
		<div className={cx(styles.thead_withSort)} onClick={() => handleSortChange(sortBy)} style={{ minWidth }}>
			<span>{title}</span>
			<div className={styles.thead_withSort_icon}>
				<ArrowSortASC
					className={
						(sort?.sortBy === sortBy &&
							cx({
								[styles.thead_withSort_ASC]: sort?.sortDir === SortDirection.ASC,
							})) ||
						''
					}
					onClick={(event: MouseEvent<SVGSVGElement>) => {
						event.stopPropagation();
						handleSortChange(sortBy, SortDirection.ASC);
					}}
				/>
				<ArrowSortDESC
					className={
						(sort?.sortBy === sortBy &&
							cx({
								[styles.thead_withSort_DESC]: sort?.sortDir === SortDirection.DESC,
							})) ||
						''
					}
					onClick={(event: MouseEvent<SVGSVGElement>) => {
						event.stopPropagation();
						handleSortChange(sortBy, SortDirection.DESC);
					}}
				/>
			</div>
		</div>
	);
};

export default TableHeadCellSortable;
